import {Component, Element, State, h, Prop} from '@stencil/core';

@Component({
  tag: 'uiaas-search-widget-help-center',
  styleUrl: 'help-center-widget.scss',
  shadow: true
})
export class HelpCenterWidget {

  @Prop() readonly country: string = 'us';
  @Prop() readonly language: string = 'en';
  @Prop() readonly link?: string;
  @Prop() readonly appName: string;
  @Prop() readonly anchorTarget: string = '';

  @Element()
    el: HTMLElement;

  @State()
    tabName: string;

  private makeLabel() {
      const language = this.language.toLowerCase();

      switch (language) {
      default:
      case 'en':
        return ['Help Center', 'Find support, popular tools and resources for all your needs in one place.', 'Explore now'];
      case 'de':
        return ['Hilfe-Center', 'Finden Sie Support, beliebte Tools und Ressourcen für alle Ihre Anforderungen an einem Ort.', 'Jetzt entdecken'];
      case 'pl':
        return ['Centrum pomocy', 'Znajdź w jednym miejscu wsparcie, popularne narzędzia i zasoby spełniające wszystkie Twoje potrzeby.', 'Dowiedz się więcej'];
      case 'fr':
        return ['Centre d\'aide', 'Trouvez l\'assistance, les outils et les ressources les plus populaires pour tous vos besoins en un seul endroit.', 'Découvrir maintenant'];
      case 'ru':
        return ['Центр поддержки', 'Найдите поддержку, популярные инструменты и ресурсы для всех ваших потребностей в одном месте.', 'Узнать больше'];
      case 'nl':
        return ['Help Center', 'Zoek op één plaats naar ondersteuning, populaire tools en hulpmiddelen voor al uw behoeften.', 'Ontdek nu'];
      case 'it':
        return ['Centro Guida', 'Trova supporto, strumenti popolari e risorse per tutte le tue esigenze in un unico posto.', 'Esplora ora'];
      case 'sv':
        return ['Hjälpcenter', 'Hitta support, populära verktyg och resurser för alla dina behov på ett och samma ställe.', 'Utforska nu'];
      case 'es':
        return ['Centro de ayuda', 'Encuentra soporte, herramientas populares y recursos para todas tus necesidades en un solo lugar.', 'Explora ahora'];
      case 'ja':
        return ['ヘルプセンター', 'サポート、人気のツール、すべてのニーズに対応するリソースを1か所で検索できます。', '詳細はこちら'];
      case 'zh':
        return ['帮助中心', '找到满足您所有需求的支持、常用工具和资源。', '即刻了解'];
      case 'fi':
        return ['Ohjekeskus', 'Löydä tuki, suositut työkalut ja resurssit kaikkiin tarpeisiisi yhdestä paikasta.', 'Tutustu nyt'];
      }
  }

  private getLink(): string {
      const supportLink = this.link ? this.link :
        `https://se.com/${this.country}/${this.language}/work/support/customer-care/contact-schneider-electric.jsp`;
  
      return supportLink;
  }

  connectedCallback() {
      const closestTabEl = this.el.closest('uiaas-search-tab');
      this.tabName = closestTabEl?.['tabName'];
  }

  render() {
      const labels = this.makeLabel();
      const link = this.getLink();
      return <uiaas-search-cta-widget-v2
        anchor-target={this.anchorTarget}
        tab-name= {this.tabName}
        event-category= "Help Center"
        header={labels[0]}
        content={labels[1]}
        url={link}
        buttonText={labels[2]}
      >
        <qds-icon
          slot="icon"
          size="large" 
          name="question-mark"
          className="dashboard-widget-icon"
        />
      </uiaas-search-cta-widget-v2>;
  }
}
